import React from 'react'

const MasterClasses = () => {
  return (
    <h1>Master Classes</h1>
  )
}

export default MasterClasses